import { BadgeField, useFieldHelper } from 'framework/ui/field';
import { useDateService } from 'framework/utils';
import { useListContext } from 'framework/list';
import moment from 'moment';
import { Badge } from 'framework/ui/mui-builder';

const StructureBadgeField = () => {
  const ds = useDateService();
  const { getValue: getCurrentCreatedAt } = useFieldHelper<string>({ source: 'createdAt' });

  const currentCreatedAt = getCurrentCreatedAt();
  const currentMoment = ds.getMomentDateObj(currentCreatedAt);
  const listContext = useListContext();

  const allRecords = listContext?.data?.items || [];

  const allCreatedDates: moment.Moment[] = allRecords
    ?.map((record: any) => {
      const createdAt =
        (typeof record.getValueBySource === 'function' && record.getValueBySource('createdAt')) || record.createdAt;

      return createdAt ? ds.getMomentDateObj(createdAt) : null;
    })
    .filter((date): date is moment.Moment => date !== null && date !== undefined);

  const maxDate = allCreatedDates?.length > 0 ? ds.getMaxDate(allCreatedDates) : undefined;

  const isActive = maxDate && currentMoment && currentMoment.isSame(maxDate);

  return (
    <BadgeField
      label="Status"
      badges={[
        <Badge key="badge" data-testid="badge" sx={{ minWidth: '60px' }} color={isActive ? 'success' : 'default'}>
          {isActive ? 'Current' : 'Previous'}
        </Badge>,
      ]}
    />
  );
};

export default StructureBadgeField;
